<template>
  <content-template
    title="Sign In"
    contained
  >
    <content-container
      description="Sign into your Morningstar Radar account with your work email and password."
      class="sign-in-view"
    >
      <div id="login-container" />
      <!-- TODO: Need design input -->
      <p v-if="displayRoleErrorMessage">
        Sorry, but you do not have the appropriate role to use this application.
      </p>
    </content-container>
  </content-template>
</template>

<script>
import ContentTemplate from '../components/ContentTemplate/ContentTemplate'
import ContentContainer from '../components/ContentContainer/ContentContainer'
import { GET_CONFIG, GET_USER } from '../graqhql/queries'
import { Roles } from '../../shared/constants'
import { hasCommonElement } from '../../shared/utils'

// jQuery and handlebars are only needed on the sign in page for the UIM widget
// REMOVE DEPENDENCIES ONCE NEW CENTRAL SIGN IN COMPONENT IS AVAILABLE
window.$ = window.jQuery = require('jquery')
window.Handlebars = require('handlebars/dist/handlebars.min')
require('uim-components-ui-widgets')

export default {
  components: {
    ContentTemplate,
    ContentContainer,
  },
  apollo: {
    config: GET_CONFIG,
  },
  data () {
    return {
      config: null,
      user: null,
    }
  },
  computed: {
    displayRoleErrorMessage () {
      return !this?.user?.roles ? false : !hasCommonElement([Roles.RADAR_OPS_LEGACY, Roles.RADAR_OPS], this.user.roles)
    },
    hasValidRole () {
      return !this?.user?.roles ? false : hasCommonElement([Roles.RADAR_OPS_LEGACY, Roles.RADAR_OPS], this.user.roles)
    },
  },
  mounted () {
    sessionStorage.clear()
    const params = {
      element: window.$('#login-container'),
      configuration: {
        environment: this.config.UIM.ENV,
        apigeeKey: this.config.UIM.APIGEE_KEY,
        showLogo: false,
        showForgotPassword: true,
        showNotAMember: false,
        success: this.onSuccess,
        error: this.onError,
      },
    }
    window.morningstar.uim.UimLoginWidget.createComponent(params)
  },
  methods: {
    async onSuccess () {
      const userResponse = await this.$apollo.query({ query: GET_USER, fetchPolicy: 'network-only' })
      this.user = userResponse.data.user
      if (this.hasValidRole) {
        this.$router.push({ name: 'home' })
      }
    },
    onError () {
      console.log('onError')
    },
  },
}
</script>

<style lang="scss">
.sign-in-view {
  .uim-widget .login-widget {
    padding: 0;
    width: auto;
  }
}
</style>
